<template>
  <div class="tes-card pa-7">
    <h1 class="tes-card__title">Заявление на смену адреса доставки ЕПД</h1>
    <p class="mt-5 font-weight-medium helvetica-medium mt-4 mb-0">Уважаемый клиент!</p>
    <p class="helvetica-roman mb-0 mt-5">
      Вы можете изменить текущий адрес доставки единого платежного документа
      от АО "Татэнергосбыт" на удобный для
      Вас адрес доставки в пределах Республики Татарстан
    </p>
    <p class="helvetica-roman mb-0 mt-2">
      Обращаем Ваше внимание что при изменении адреса доставки по предыдущему
      адресу
      единые платежные документы направляться не будут.
    </p>
    <v-container fluid mt-3>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col sm="2" cols="12" class="pa-0">
            <p class="font-weight-medium helvetica-medium mt-2">
              Лицевой счет:
              <sup class="star">*</sup>
            </p>
          </v-col>
          <v-col sm="4" cols="12" class="pa-0">
            <PersonalAccountSelect
              v-model="selectedAccount"
              :is-local="true"
              :only-is-owner="true"
            ></PersonalAccountSelect>
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="2" cols="12" class="pa-0">
            <p class="font-weight-medium helvetica-medium mt-2">Индекс:</p>
          </v-col>
          <v-col sm="4" cols="12" class="pa-0">
            <v-text-field
              class="custom-text-field helvetica-roman fs-16"
              autocomplete="new-password"
              v-model="postalIndex"
              v-mask="indexMask"
              single-line
              outlined
              :rules="indexRules"
              @change="dropAddressGuid"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="2" cols="12" class="pa-0">
            <p class="font-weight-medium helvetica-medium mt-2">
              Район:
              <sup class="star">*</sup>
            </p>
          </v-col>
          <v-col sm="4" cols="12" class="pa-0">
            <v-combobox
              :items="areas"
              v-model="selectedArea"
              autocomplete="new-password"
              item-value="value"
              item-text="name"
              outlined
              return-object
              @change="changeArea"
              :disabled="areasLoading"
              :loading="areasLoading"
              :rules="requiredRules"
              validate-on-blur
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Район не найден</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-combobox>
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="2" cols="12" class="pa-0">
            <p class="font-weight-medium helvetica-medium mt-2">Населённый пункт:</p>
          </v-col>
          <v-col sm="4" cols="12" class="pa-0">
            <v-combobox
              :items="localities"
              v-model="selectedLocality"
              autocomplete="new-password"
              item-value="value"
              item-text="name"
              outlined
              return-object
              @change="changeLocality"
              :disabled="localitiesLoading || !selectedArea || selectedArea && selectedArea.socr === 'г'"
              :loading="localitiesLoading"
              validate-on-blur
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Населенный пукнт не найден</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-combobox>
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="2" cols="12" class="pa-0">
            <p class="font-weight-medium helvetica-medium mt-2">
              Улица:
              <sup class="star">*</sup>
            </p>
          </v-col>
          <v-col sm="4" cols="12" class="pa-0">
            <v-combobox
              :items="streets"
              v-model="selectedStreet"
              autocomplete="new-password"
              item-value="value"
              item-text="name"
              outlined
              return-object
              @change="changeStreet"
              :rules="requiredRules"
              validate-on-blur
              :disabled="selectedArea && selectedArea.socr !== 'г' ? streetsLoading || !selectedLocality : !selectedArea || streetsLoading"
              :loading="streetsLoading"
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Улица не найдена</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-combobox>
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="2" cols="12" class="pa-0">
            <p class="font-weight-medium helvetica-medium mt-2">
              Дом:
              <sup class="star">*</sup>
            </p>
          </v-col>
          <v-col sm="4" cols="12" class="pa-0">
            <v-combobox
              :items="houses"
              autocomplete="new-password"
              item-value="value"
              item-text="name"
              v-model="selectedHouse"
              @change="dropAddressGuid"
              outlined
              return-object
              :rules="requiredRules"
              validate-on-blur
              :disabled="housesLoading || !selectedStreet"
              :loading="housesLoading"
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Дом не найден</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-combobox>
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="2" cols="12" class="pa-0">
            <p class="font-weight-medium helvetica-medium mt-2">Квартира:</p>
          </v-col>
          <v-col sm="4" cols="12" class="pa-0">
            <v-text-field
              class="custom-text-field helvetica-roman fs-16"
              v-model="flat"
              single-line
              outlined
              :disabled="!selectedHouse"
              @change="dropAddressGuid"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-row>
        <v-col md="5" cols="12" class="pa-0 text-center text-sm-left">
          <v-btn @click="seeChanges" class="blue-button" dark :loading="loading">Просмотр</v-btn>
        </v-col>
        <v-col md="1" cols="12" class="pa-0 text-center text-sm-left">
          <v-btn
            outlined
            class="mr-sm-4 mt-3 mt-md-0 outlined-transparent-button"
            :loading="loading"
            @click="clearForm"
          >Отмена</v-btn>
        </v-col>
        <v-col md="1" cols="12" class="pa-0 text-center text-sm-left">
          <v-btn
            @click="saveChanges"
            class="green-button mt-3 mt-md-0"
            dark
            :loading="loading"
            :disabled="!save"
          >Сохранить</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PersonalAccountSelect from "../../../components/common/PersonalAccountSelect.vue";
import { mapState, mapGetters } from "vuex";
import { mask } from "vue-the-mask";

export default {
  directives: {
    mask
  },
  layout: "main",
  components: {
    PersonalAccountSelect
  },
  data() {
    return {
      selectedAccount: null,
      loading: false,
      areasLoading: false,
      localitiesLoading: false,
      streetsLoading: false,
      housesLoading: false,
      selectedArea: null,
      selectedLocality: null,
      selectedStreet: null,
      selectedHouse: null,
      addressGuid: null,
      postalIndex: "",
      flat: "",
      indexRules: [
        v => {
          if (v.length > 0) {
            return (
              (v && v.substring(0, 2) === "42") ||
              'Индекс должен начинаться с "42"'
            );
          } else {
            return true;
          }
        }
      ],
      requiredRules: [v => !!v || "Поле обязательно"],
      areasError: false,
      localitiesError: false,
      housesError: false,
      streetsError: false,
      indexMask: "42####"
    };
  },
  computed: {
    ...mapState("statements", ["areas", "localities", "streets", "houses"]),
    ...mapState("account", ["userSettings"]),
    save () {
      return !!(this.selectedAccount &&
        this.selectedArea &&
        this.selectedStreet &&
        this.selectedHouse);
    }
  },
  methods: {
    dropAddressGuid() {
      this.addressGuid = null;
    },
    changeArea(event) {
      this.addressGuid = null;
      if (event && this.areas.find(item => event === item)) {
        this.selectedLocality = null;
        this.selectedStreet = null;
        this.selectedHouse = null;
        let request;
        if (event.socr === "г") {
          request = "statements/getStreets";
          this.streetsLoading = true;
        } else {
          this.localitiesLoading = true;
          request = "statements/getLocalities";
        }
        this.$store.dispatch(request, event.value).then(() => {
          this.localitiesLoading = false;
          this.streetsLoading = false;
        });
      } else {
        this.selectedArea = null;
      }
    },
    changeLocality(event) {
      this.addressGuid = null;
      if (event && this.localities.find(item => event === item)) {
        this.selectedStreet = null;
        this.selectedHouse = null;
        this.streetsLoading = true;
        this.$store.dispatch("statements/getStreets", event.value).then(() => {
          this.streetsLoading = false;
        });
      } else {
        this.selectedLocality = null;
      }
    },
    changeStreet(event) {
      this.addressGuid = null;
      if (event && this.streets.find(item => event === item)) {
        this.selectedHouse = null;
        this.housesLoading = true;
        this.$store.dispatch("statements/getHouses", event.value).then(() => {
          this.housesLoading = false;
        });
      } else {
        this.selectedStreet = null;
      }
    },
    changeHouse(event) {
      this.addressGuid = null;
      if (!event && !this.houses.find(item => event === item)) {
        this.selectedHouse = null;
      }
    },
    validate() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        let payload = {
          text: "Заполните необходимые поля",
          type: "error"
        };
        this.$store.commit("common/" + "ADD_ALERT", payload, { root: true });
        return false;
      }
    },
    clearForm() {
      this.selectedAccount = null;
      this.selectedArea = null;
      this.selectedLocality = null;
      this.selectedStreet = null;
      this.selectedHouse = null;
      this.postalIndex = "";
      this.flat = "";
      this.addressGuid = null;
    },
    generateRequestData() {
      let data = {
        userId: this.userSettings.userGuid,
        domHoz: this.selectedAccount.domHoz,
        index: this.postalIndex,
        areaGuid: this.selectedArea.value,
        townGuid: this.selectedLocality
          ? this.selectedLocality.value
          : this.selectedArea.value,
        streetGuid: this.selectedStreet.value,
        houseGuid: this.selectedHouse.value,
        flat: this.flat
      };
      return data;
    },
    seeChanges() {
      if (!this.validate()) return false;

      let data = this.generateRequestData();
      this.loading = true;
      this.$store
        .dispatch("statements/previewStatement", data)
        .then(({ addressGuid, html }) => {
          this.loading = false;

          this.addressGuid = addressGuid;

          const key = Math.random() * Math.random() * Math.random();
          localStorage.setItem(key, html);
          let routeData = this.$router.resolve({
            path: "/preview",
            query: {
              title: "Заявление на смену адреса доставки ЕПД",
              key
            }
          });

          window.open(routeData.href, "_blank");
        })
        .catch(() => {
          this.loading = false;
        });
    },
    saveChanges() {
      this.loading = true;
      // let data = {
      //   userId: this.userSettings.userGuid,
      //   domHoz: this.selectedAccount.domHoz,
      //   addressGuid: this.addressGuid
      // };
      this.$store.dispatch("statements/saveStatement", this.generateRequestData()).then(() => {
        this.loading = false;
        this.clearForm();
      });
    }
  },
  created() {
    this.areasLoading = true;
    this.$store.dispatch("statements/getAreas").then(() => {
      this.areasLoading = false;
    });
  }
};
</script>

<style lang="scss" scoped>
.star {
  color: #ff9933;
}
</style>
